module.exports = __webpack_public_path__ + "static/media/sms-chat.b8af3b61.png";